import React, { useState } from 'react';
import DropdownMenu, { DropdownItemRadio, DropdownItemGroupRadio } from '@atlaskit/dropdown-menu';
import Button from '@atlaskit/button';
import Form, { Field } from '@atlaskit/form';
import { DatePicker } from '@atlaskit/datetime-picker';
import './date-filter.scss';

type DateRangeType = {
  from: string;
  to: string;
};
interface Props {
  selected?: string;
  // eslint-disable-next-line no-unused-vars
  dateValue: (dateRange: DateRangeType) => void;
  // eslint-disable-next-line no-unused-vars
  onSelected?: (selected: string) => void;
}

const rangeOption = [
  { text: 'Last 24 hours', value: 1 },
  { text: 'Last 7 days', value: 7 },
  { text: 'Last 14 days', value: 14 },
  { text: 'Last 30 days', value: 30 },
  { text: 'Last 90 days', value: 90 },
  { text: 'Last 12 months', value: 365 },
  { text: 'Custom', value: 0 },
];

const DateFilter = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const generateDateRange = (value: number) => {
    if (value === 0) setIsOpen(true);
    else {
      if (isOpen) setIsOpen(false);
      const date = new Date();
      date.setDate(date.getDate() - value);
      const fromTimeStamp = (date.getTime() * 1000).toString();
      const toTimeSTamp = (new Date().getTime() * 1000).toString();
      props.dateValue({
        from: fromTimeStamp,
        to: toTimeSTamp,
      });
    }
    props.onSelected && props.onSelected(value.toString());
  };
  const customDateFilter = (formDate: any) => {
    const fromTimeStamp = (new Date(formDate['from-datetime-picker']).getTime() * 1000).toString();
    const toTimeSTamp = (new Date(formDate['to-datetime-picker']).getTime() * 1000).toString();
    props.dateValue({
      from: fromTimeStamp,
      to: toTimeSTamp,
    });
  };
  return (
    <div className="date-filter">
      <DropdownMenu
        trigger="Time period"
        triggerType="button"
        position="bottom left"
        testId="dateFilter"
        triggerButtonProps={{
          className: 'trigger-button',
        }}
      >
        <DropdownItemGroupRadio id="actions" data-testid="date-groupdropdown">
          {rangeOption.map((range, index) => {
            return (
              <DropdownItemRadio
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                key={index} // @ts-ignore
                id={index}
                onClick={() => generateDateRange(range.value)}
                data-testid={range.text}
                isSelected={props.selected === range.value.toString()}
              >
                {range.text}
              </DropdownItemRadio>
            );
          })}
        </DropdownItemGroupRadio>
        {isOpen && (
          <Form onSubmit={(formState: unknown) => customDateFilter(formState)}>
            {({ formProps }) => (
              <form {...formProps}>
                <div>
                  <div className="from-datetime-picker">
                    <Field
                      name="from-datetime-picker"
                      data-testId="from-datetime-picker"
                      isRequired={false}
                      defaultValue={new Date().toDateString()}
                    >
                      {({ fieldProps }) => <DatePicker {...fieldProps} dateFormat="MMM DD, YYYY" />}
                    </Field>
                  </div>
                  <div className="to-datetime-picker">
                    <Field
                      name="to-datetime-picker"
                      data-testId="to-datetime-picker"
                      isRequired={false}
                      defaultValue={new Date().toDateString()}
                    >
                      {({ fieldProps }) => <DatePicker {...fieldProps} dateFormat="MMM DD, YYYY" />}
                    </Field>
                  </div>
                </div>
                <div className="apply-datetime">
                  <Button type="submit" appearance="primary" testId="apply-filter">
                    Apply
                  </Button>
                </div>
              </form>
            )}
          </Form>
        )}
      </DropdownMenu>
    </div>
  );
};

export default DateFilter;
